// Swiper is imported already

if (!customElements.get('product-detail-swiper')) {
  class ProductDetailSwiper extends HTMLElement {
    constructor() {
      super();

      this.swiperElement = this.querySelector('[data-product-detail-swiper]');

      this.swiperOptions = {
        direction: 'horizontal',
      };

      this.init();
    }

    init() {
      window.addEventListener('load', (event) => {
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      });
      Fancybox.bind('[data-fancybox]', {
        animated: false,
        showClass: false,
        mainClass: 'image-zoom',
      });
    }
  }

  customElements.define('product-detail-swiper', ProductDetailSwiper);
}

if (!customElements.get('product-info')) {
  class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.productForm = this.querySelector('product-form');
      this.productFormQuantity = this.productForm?.querySelector('input[name="quantity"]');
      this.quantityInput = this.querySelector('quantity-input');
      this.quantityInputElement = this.quantityInput?.querySelector('input[name="quantity"]');
      this.quantityInputElement?.addEventListener('change', () => {
        this.handleQuantityInput();
      });

      // Set the variant ID on the product-stock-notification web component
      const klaviyoApiFilled = document.querySelector('[data-klaviyo-api-filled]').dataset
        .klaviyoApiFilled;
      const klaviyoBisEnabled = document.querySelector('[data-klaviyo-bis-enabled]').dataset
        .klaviyoBisEnabled;
      const currentVariantId = document.querySelector('input[name="id"]').value;
      const stockInformation = document.querySelector('.stock-information');

      if (klaviyoApiFilled == 'true' && klaviyoBisEnabled == 'true') {
        if (document.querySelector('.product-stock-notification')) {
          document.querySelector('.product-stock-notification').dataset.variantId =
            currentVariantId;
        }
        if (stockInformation) {
          stockInformation.classList.add('hidden');
        }
      } else {
        if (stockInformation) {
          stockInformation.classList.remove('hidden');
        }
      }
    }

    async checkCartAndInventory() {
      const allowBackorder = document.querySelector('[data-backorder]').dataset.backorder;
      if (allowBackorder === 'true') return;

      // Get variant and inventory quantity from the form
      const variantId = this.querySelector('input[name="id"]');
      const inventoryQty = this.querySelector('input[name="inventory_quantity"]');
      const submitButton = this.querySelector(
        '[type="submit"]:not(.product-stock-notification__form-button)'
      );
      const submitButtonText = submitButton?.querySelector('[data-add-to-cart-button-text]');

      // Check if this is a student embroidery product
      const hasEmbroideryConfigurator = this.querySelector('embroidery-configurator-student');

      // If it's a student embroidery product, don't modify the button state here
      if (hasEmbroideryConfigurator) return;

      // Fetch the cart data
      const cart = await fetch('/cart.js')
        .then((response) => response.json())
        .catch((error) => console.error('Error fetching cart data:', error));

      let cartItemQuantity = 0;

      // Calculate the quantity of the current product in the cart
      if (cart && cart.items) {
        cart.items.forEach((item) => {
          if (item.variant_id == variantId.value) {
            cartItemQuantity = item.quantity;
          }
        });
      }

      // Check if the cart quantity equals or exceeds the maximum inventory
      if (cartItemQuantity >= inventoryQty.value) {
        if (submitButton) submitButton.disabled = true;
        if (submitButtonText) submitButtonText.textContent = window.variantStrings.soldOut;
      } else {
        if (submitButton) submitButton.disabled = false;
        if (submitButtonText) submitButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    /**
     * handleQuantityInput
     * @description Set the quantity from the quantity input web component to the product form web component.
     */
    handleQuantityInput() {
      this.productFormQuantity.value = this.quantityInputElement.value;
    }
  }
  customElements.define('product-info', ProductInfo);
}
